(function () {
  var KEY = 'sc_wishlist';

  function getList() {
    try {
      var raw = localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveList(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('sc:wishlist-updated', { detail: list }));
  }

  function has(handle) {
    return getList().indexOf(handle) > -1;
  }

  function toggle(handle) {
    var list = getList();
    var i = list.indexOf(handle);
    if (i > -1) {
      list.splice(i, 1);
    } else {
      list.push(handle);
    }
    saveList(list);
    return has(handle);
  }

  function remove(handle) {
    var list = getList().filter(function (h) { return h !== handle; });
    saveList(list);
  }

  function refreshButtons() {
    var list = getList();
    document.querySelectorAll('[data-sc-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-handle');
      btn.classList.toggle('is-active', list.indexOf(handle) > -1);
    });
    document.querySelectorAll('[data-sc-wishlist-count]').forEach(function (el) {
      el.textContent = list.length;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sc-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-handle');
    if (!handle) return;
    toggle(handle);
    refreshButtons();
  });

  document.addEventListener('sc:wishlist-updated', refreshButtons);
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) refreshButtons();
  });
  window.addEventListener('pageshow', refreshButtons);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshButtons);
  } else {
    refreshButtons();
  }

  window.scWishlist = { getList: getList, has: has, toggle: toggle, remove: remove };
})();
